import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

  const handleLogin = async () => {
    const response = await fetch(`${API_URL}/api/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    console.log("Raw response:", response);
    const data = await response.json();
    console.log("Parsed JSON:", data);

    if (response.ok) {
      // login(data.user, data.access_token);
      login(username, data.access_token);
      navigate("/dashboard");
    } else {
      alert("ログイン失敗");
    }
  };

  return (
    <div style={styles.buttonContainer}>
      <input type="text" placeholder="ユーザー名" value={username} onChange={(e) => setUsername(e.target.value)} />
      <input type="password" placeholder="パスワード" value={password} onChange={(e) => setPassword(e.target.value)} />
      <button onClick={handleLogin}>ログイン</button>
    </div>
  );
};

const styles = {
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "50px",
    gap: "10px"
  },
};

export default Login;